import { Injectable } from '@angular/core';
import { ToroNotification } from '../api/models/toro-notification.model';

@Injectable()
export class LoggingService
{
    constructor() { }

    static log(message: any, callerInfo?: object)
    {
        const callerName = callerInfo ? callerInfo.constructor.name : null;

        if (typeof message === 'string')
        {
            //console.log(`${callerName ? '[' + callerName + ']: ' : ''}${message}`);
        }
        else
        {
            if (callerInfo)
            {
                console.log(`[${callerName}]: `);
            }
        }
    }

    static logNotification(notification: ToroNotification)
    {
        if (!(notification instanceof ToroNotification)) return;

        //console.log(`${notification.ValueType}:\n`, notification.Value);
    }

    static error(textToLog: string, callerInfo?: object)
    {
        const callerName = callerInfo ? callerInfo.constructor.name : null;
        console.error(`${callerName ? '[' + callerName + ']: ' : ''}${textToLog}`);
    }
}
